import axios from '../base/axios';
import API_KEY from './key';

const GET_NOWPLAYING = 'flixfrenzy/redux/GET_NOWPLAYING';

// eslint-disable-next-line default-param-last
const nowPlayingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_NOWPLAYING:
      return action.payload;
    default:
      return state;
  }
};

export const getNowPlaying = () => (dispatch) => {
  axios.get(`movie/now_playing?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_NOWPLAYING,
      payload: res.data,
    });
  });
};

export default nowPlayingReducer;
